import cover from "../../assets/images/cover.png";
import React, { useContext } from "react";
import "./PageTitle.scss";
import "./MenuPage.scss"
import logo from "../../assets/images/poweredByLogo.svg";
import { RefreshDataReactContext } from "../../contexts/RefreshDataContext";
import { CompanyReactContext } from "../../contexts/CompanyContext";

export const UserPageTitle = ({ size, title, subTitle, subTitleBold, customComponent, noLogo }) => {
    const refreshDataContext = useContext(RefreshDataReactContext)
    const companyContext = useContext(CompanyReactContext)
    const companyLogo = companyContext.companyLogoUrl
    const hasLogo = companyLogo && !noLogo;
    return <div className={`PageTitle ${hasLogo ? 'has-logo' : ''} ${size}`}>
        <div className="PageTitleAbsolute">
            <img src={cover} alt="" />
            <div className="gradient"></div>
        </div>
        <div className="LogosRow">
            <div className="WeezBeeLogo">
                <img src={logo} alt="" />
            </div>
            {companyLogo && !noLogo ? <div className="customerLogo">
                {companyLogo && <img src={`${companyLogo}`} key={refreshDataContext.key} alt="" />}
            </div> : ''}
        </div>
        <div className="TitleRow">
            <div className="TitleWrapper">
                <div className="TitleText" title={title} aria-label={title}>{title}</div>
                <div className="SubtitleText" title={`${subTitle || ''}${subTitleBold ? ` ${subTitleBold}` : ''}`} aria-label={`${subTitle || ''}${subTitleBold ? ` ${subTitleBold}` : ''}`}>
                    {subTitle}{' '}
                    <span className="SubtitleBoldText" dir="auto">{subTitleBold}</span>
                </div>
            </div>
            <div className="customComponent">
                {customComponent}
            </div>
        </div>
    </div>
}